import Skeleton from "@/v2-ui/skeleton"
import cn from "@/v2-ui/utils/utils.cn"

// 4-tile placeholder for the KPI strip. Mirrors the structure of
// `StatusKpis` (same grid, same tile chrome, same spacing) so the
// layout doesn't shift when the real numbers land. Each tile only
// pulses the value + sub-line; the eyebrow label position stays
// empty rather than pulsing too because pulsing every line in
// every tile reads as "more is wrong here than there is".
function StatusKpisSkeleton() {
  return (
    <section
      aria-hidden
      className="grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4"
    >
      {Array.from({ length: 4 }).map((_, i) => (
        <KpiTileSkeleton key={i} />
      ))}
    </section>
  )
}

function KpiTileSkeleton() {
  return (
    <div
      className={cn(
        "flex flex-col gap-2 rounded-lg border border-border/60 bg-card px-4 py-4",
        "border-l-4 border-l-border/60",
      )}
    >
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-7 w-20" />
      <Skeleton className="h-3 w-32" />
    </div>
  )
}

export default StatusKpisSkeleton
